// extracted by mini-css-extract-plugin
export default {"header_wrapper":"ModalEditPatientProfile_header_wrapper__ADGHT","input_wrapper":"ModalEditPatientProfile_input_wrapper__BDt1r"};